import axios, { AxiosRequestConfig, AxiosRequestHeaders } from "axios";
// import services from "./services";
import { Providers } from "@microsoft/mgt";
interface AdaptAxiosRequestConfig extends AxiosRequestConfig {
  headers: AxiosRequestHeaders;
}

// Interceptors
axios.interceptors.request.use(
  async (config): Promise<AdaptAxiosRequestConfig> => {
    try {
      if (config.headers) {
        const token = await Providers.globalProvider.getAccessToken();
        config.headers.Authorization = `Bearer ${token}`;
        config.headers.Accept = "application/json, text/plain, */*";

        if (config.url && config.url.indexOf("/storage/") > -1) {
          config.headers["Content-Type"] = "multipart/form-data";
        } else {
          config.headers["Content-Type"] = "application/json";
        }
      }
      return config;
    } catch (error: unknown) {
      return Promise.reject(error);
    }
  },
  function (err) {
    return Promise.reject(err);
  }
);
